import { render, staticRenderFns } from "./DrugsInteractionsButton.vue?vue&type=template&id=66c4f8c7"
import script from "./DrugsInteractionsButton.vue?vue&type=script&lang=js"
export * from "./DrugsInteractionsButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports